module.exports = __webpack_public_path__ + "static/icons/icon-snocountry-a2786dface83aa49a735b5cade43f475.svg";